import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Fiveanalysisyeppy = () => {
  return (
    <div className="fiveanalysis_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>5 Why Analysis for Yeppy</h2>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="five_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/five_analy.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1507}
              />
              <StaticImage
                src="../../../images/case-studies/yeppy/five_mob_view.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1437}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Fiveanalysisyeppy;
